// extracted by mini-css-extract-plugin
export default {"container":"promotion-title_container__2Nmtv"};